import _get from 'lodash/get'
import { mapGetters } from 'vuex'
import RouteUtils from '~/route.utils'
import seo from '@wptv/seo'
import TextUtils from '../../shared/text.utils'

export default {
  head () {
    let coverUrl
    if (this.headData.coverUrl) {
      if (!this.headData.coverUrl?.startsWith('http')) {
        if (!this.$config.confetti.public.imageDomain.endsWith('/') && !this.headData.coverUrl?.startsWith('/')) {
          coverUrl = this.$config.confetti.public.imageDomain + '/'
        } else {
          coverUrl = this.$config.confetti.public.imageDomain
        }
        coverUrl += this.headData.coverUrl
      } else {
        coverUrl = this.headData.coverUrl
      }
    } else {
      coverUrl = null
    }
    const socialMetaTags = seo.generateSocialMetaTags(
      `${this.$config.confetti.public.root.wassup}${this.$route.path}`,
      this.headData.socialMetaTitle,
      this.headData.socialMetaDescription,
      coverUrl,
      '',
      '',
      this.$config.confetti.public.root.wassup,
      'VOD'
    )

    const head = {
      title: TextUtils.getSlicedTitle(this.headData.pageTitle),
      meta: [
        { hid: 'description', name: 'description', content: TextUtils.getSlicedDescription(this.headData.pageDescription) },
        ...socialMetaTags
      ],
      script: [
        {
          type: 'application/ld+json',
          json: seo.getStructuredData(this.headData.item, this.$router, this.$config.confetti.public.root.wassup)
        },
        {
          type: 'application/ld+json',
          json: seo.getBreadcrumbList(this.headData.item, `${this.$route.path}`, this.$config.confetti.public.root.wassup)
        }
      ]
    }

    if (this.headData['navik::pageName']) {
      head.meta.push({ name: 'navik::pageName', content: this.headData['navik::pageName'] })
    }

    if (this.headData['navik::pageType']) {
      head.meta.push({ name: 'navik::pageType', content: this.headData['navik::pageType'] })
    }

    return head
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      userDiscounts: 'user/getUserDiscounts',
      redirectTo: 'fip/getRedirectTo'
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('fip/resetRedirectTo')

    if (Object.keys(RouteUtils.ROUTE.FIP).some(route => RouteUtils.ROUTE.FIP[route] === to.name) || to.name === 'payment') {
      this.$store.commit('fip/cleanHistory', _get(from, 'params.id'))
    } else {
      this.$store.commit('fip/resetHistory')
    }

    next()
  },
  mounted () {
    // this is done to force the focus on it when arriving on the fip - US #6725
    // if it's no longer useful, remove tabindex on the h1 in FipTitle
    const h1ToFocus = this.$refs.fipHeader?.$el?.getElementsByTagName('h1')
    if (h1ToFocus && h1ToFocus[0]) {
      h1ToFocus[0].focus()
    }
  }
}
